import { createSelector } from 'reselect';
import { UploadsState } from './types';

export const getUploads = (state: any) => state.assets;

export const getUploadsSelection = createSelector(
    getUploads,
    (
        assets,
    ): {
        selectedUploads: UploadsState['checked'];
        /* todo: this is an array! do we need to check all of them? */
    } => ({ selectedUploads: assets.checked }),
);

export const getAssetsActionProgress = createSelector(
    getUploads,
    (
        assets,
    ): {
        renamingInProgress: UploadsState['renamingInProgress'];
        deleteInProgress: UploadsState['deleteInProgress'];
    } => ({
        renamingInProgress: assets.renamingInProgress,
        deleteInProgress: assets.deleteInProgress,
    }),
);
